<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
			<el-dialog title="用户管理" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="24" class="rowTops">
						<el-form-item type="type" label="所在部门" prop="sjcd">
							<!-- <el-input v-model.trim="ruleForm.sjcd" placeholder="所在部门" @focus="focusval($event)" @blur="blurval1($event)"></el-input> -->
              <el-cascader ref="cascaderAddr" placeholder="所在部门" v-model="cascaderModel" :options="datatree" :show-all-levels="false" @change="handleChange" :props="{ value: 'id',label: 'name',children: 'children', expandTrigger: 'hover', checkStrictly: true}" filterable style="width: 100%;"></el-cascader>
						</el-form-item>
						<!-- <transition name="el-zoom-in-center">
							<div v-show="khdwshow" class="rowTopa">
								<el-tree :data="datatree" class="paddingtree" :expand-on-click-node="false" :highlight-current='true' :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick" node-key='id' ref="treeList" :filter-node-method="filterNode" :default-expanded-keys='[treesid]'>
								</el-tree>
							</div>
						</transition> -->
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="登录账户" prop="dlzh">
							<el-input type="type" placeholder="登录账户" class="from-el-input" v-model.trim="ruleForm.dlzh" :disabled="usernanmebj"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="昵称" prop="yhxm">
							<el-input type="type" placeholder="昵称" class="from-el-input" v-model.trim="ruleForm.yhxm"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12" v-if='this.state!="bj"'>
						<el-form-item type="type" label="用户密码" prop="userpassword">
							<el-input placeholder="用户密码" v-model="ruleForm.userpassword" show-password></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if='this.state!="bj"'>
						<el-form-item type="type" label="确认密码" prop="repassword">
							<el-input placeholder="确认密码" v-model="ruleForm.repassword" show-password></el-input>
						</el-form-item>
					</el-col> -->
					<el-col :span="12">
						<el-form-item type="type" label="手机号" prop="phone">
							<el-input type="type" placeholder="手机号" class="from-el-input" v-model.trim="ruleForm.phone"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="状态" prop="status">
							<el-select v-model.trim="ruleForm.status" clearable placeholder="状态" style="width: 100%;">
								<el-option v-for="(item,i) in ztstate" :key="i" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="邮箱" prop="youx">
							<el-input type="type" placeholder="邮箱" class="from-el-input" v-model.trim="ruleForm.youx"></el-input>
						</el-form-item>
					</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="类型" prop="type">
          		<el-select v-model.trim="ruleForm.type" clearable placeholder="类型" style="width: 100%;">
          			<el-option v-for="(item,i) in typestate" :key="i" :label="item.name" :value="item.id">
          			</el-option>
          		</el-select>
          	</el-form-item>
          </el-col>

					<el-col :span="24">
						<el-form-item type="type" label="角色" prop="youx">
							<div class="trees">
								<el-checkbox-group v-model.trim="ruleForm.roleIds">
									<el-checkbox v-for="(item,i) in jslist" :label="item.id" :key="i">{{item.roleName}}</el-checkbox>
								</el-checkbox-group>
							</div>
						</el-form-item>
					</el-col>

				</el-row>

				<span slot="footer" class="dialog-footer">
                    <el-form-item>
                        <el-button round @click="empty()" type="warning">取消</el-button>
                        <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
                        <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
                    </el-form-item>
                </span>
			</el-dialog>
		</el-form>
		<!--弹出框-->
	</div>
</template>

<script>
	import { usersave, orglist, rolelist, userupdate, userinfo } from "@/api/api.js";
	export default {
		props: {
			mystate: Array
		},
		data() {
			let validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'))
					// password 是表单上绑定的字段
				} else if(value !== this.ruleForm.userpassword) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			}
			return {
				dialogVisible: true,
				ruleForm: {
					dlzh: '',
					yhxm: '',
					userpassword: '',
					repassword: '',
					danw: '',
					status: 1,
					youx: '',
          type: '',
					phone: '',
					roleIds: [],
					sjcd: '',
				},
				rules: {
					dlzh: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					yhxm: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					userpassword: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
					],
					repassword: [
						{ required: true, validator: validatePass2, trigger: 'blur' }
					],
					danw: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					status: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					youx: [
						{ required: false, message: "请输入必填项", trigger: "blur" },
						//{ pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '请输入有效的邮箱', trigger: 'blur' },
					],
          type: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					roleIds: [
						{ required: true, message: '请输入必选项', trigger: 'change' },
					],
					phone: [
						{ required: true, message: '请输入必选项', trigger: 'blur' },
						//{ pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' },
					],
					sjcd: [
						{ required: true, message: '请输入必选项', trigger: 'change' },

					],

				},
				ztstate: [
					{ name: '启用', id: 1 },
					{ name: '停用', id: 0 },
				],
        typestate: [
					{ name: '省', id: '省' },
					{ name: '市', id: '市' },
          { name: '县', id: '县' },
          { name: '人员', id: '人员' },
          { name: '暗访', id: '暗访' },
				],
				jslist: [],
				state: '',
				row: null,
				khdwshow: false,
				datatree: [],
				defaultProps: { /// tree设置
					children: 'children',
					label: 'name'
				},
				khdwshow: false,
				treesid: '',
				sjcdid: '',

        //编辑状态时登录用户name不可编辑
        usernanmebj: false,

        cascaderModel: '',
			};
		},
		created() {
			//初始化数据
		},
		components: {

		},
    // watch: {
    //   "ruleForm.sjcd": {
    //     handler(newval, oldval) {
    //       this.$refs.treeList.filter(newval);
    //     },
    //   },
    // },
		methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
			handleNodeClick(data, e) {
				this.sjcdid = data.id;
				this.ruleForm.sjcd = data.name;
			},
      handleChange(value) {
        // console.log(this.$refs["cascaderAddr"].getCheckedNodes()[0].value)
        this.sjcdid = this.$refs["cascaderAddr"].getCheckedNodes()[0].value;
        this.ruleForm.sjcd = this.$refs["cascaderAddr"].getCheckedNodes()[0].label;
        this.$refs.cascaderAddr.dropDownVisible = false;
        // console.log(this.cascaderModel)
      },
			focusval(e) {
				this.khdwshow = true
			},
			blurval1(e) {
				let _this = this
				setTimeout(function() {
					_this.khdwshow = false
				}, 200)
			},

			cancel() {

			},
			deteRmine(formName, type) {
				this.$refs[formName].validate(valid => {
					if(valid) {
						if(type == 'xz') {
							let params = {
								deptIdList: this.sjcdid, //部门id
								deptName: this.ruleForm.sjcd, //部门名称
								email: this.ruleForm.youx, //邮箱
								mobile: this.ruleForm.phone, //手机号
								nickname: this.ruleForm.yhxm, //昵称
								password: this.ruleForm.repassword, //密码
								roleIdList: this.ruleForm.roleIds, //角色id
								status: this.ruleForm.status, //状态
                type: this.ruleForm.type, //类型
								username: this.ruleForm.dlzh, //用户名

							};
							usersave(params).then((res) => {
								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						} else {
							let params = {
								deptIdList: this.sjcdid, //部门id
								deptName: this.ruleForm.sjcd, //部门名称
								email: this.ruleForm.youx, //邮箱
								mobile: this.ruleForm.phone, //手机号
								nickname: this.ruleForm.yhxm, //昵称
								password: this.ruleForm.repassword, //密码
								roleIdList: this.ruleForm.roleIds, //角色id
								status: this.ruleForm.status, //状态
								username: this.ruleForm.dlzh, //用户名
                type: this.ruleForm.type, //类型

								id: this.row.id
							};
							userupdate(params).then((res) => {

								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						}
					}
				});
			},
			empty() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
			handleClose() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
      getTreeData(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].children.length < 1) {
                // 最后一级没有数据将children变成undefined
                data[i].children = undefined;
            } else {
                // children不为空时继续调用该方法
                this.getTreeData(data[i].children);
            }
        }
        return data;
      },
		},
		mounted() {
			this.state = this.mystate[0];

			orglist({}).then((res) => {
				// this.datatree = res.data;
        this.datatree = this.getTreeData(res.data);

				if(this.state == 'bj') {
          this.usernanmebj = true;
					this.row = this.mystate[1];
					userinfo({ id: this.row.id }).then((res) => {
						console.log(res);
						this.ruleForm.youx = res.data.email; //邮箱
						this.ruleForm.phone = res.data.mobile; //手机号
						this.ruleForm.yhxm = res.data.nickname; //昵称
						this.ruleForm.status = res.data.status; //状态
						this.ruleForm.dlzh = res.data.username; //状态
            this.ruleForm.type = res.data.type, //类型
						this.ruleForm.roleIds = res.data.roleIdList;
						//this.treesid = res.data.deptIdList;
						this.sjcdid = res.data.deptIdList
						this.$nextTick(function() {
							// console.log(res.data.deptIdList)
							// this.$refs.treeList.setCurrentKey(this.sjcdid);
							// this.ruleForm.sjcd = this.$refs.treeList.getCurrentNode().name;
              this.sjcdid = res.data.deptIdList;
              this.cascaderModel = res.data.deptIdList;
              this.ruleForm.sjcd = res.data.deptIdList;
						})
					})
				} else {
          this.usernanmebj = false;
        }
			})
			let params = {
				// pageSize: 0,
				pageNum: 0,
			}
			rolelist(params).then((res) => {
				//console.log(res);

				this.jslist = res.data;
				/*if(this.state == 'bj') {
					this.ruleForm.roleIds = this.row.roleIdList

				}*/

			})

		}
	};
</script>

<style scoped="scoped">
	@import url('../../../common/css/mangementall.css');
	>>>.el-dialog {
		width: 800px;
	}

	>>>.el-dialog__body {
		max-height: 500px;
		overflow: auto;
	}

	.trees {
		width: 98%;
		float: left;
		max-height: 300px;
		height: 60px;
		line-height: 30px;
		padding-left: 2%;
		margin-top: 5px;
	}

	.rowTopa {
		position: absolute;
		left: 100px;
		top: 37px;
		right: 0px;
		margin: auto;
		max-height: 300px;
		background: #fff;
		border: 1px solid #e3e3e3;
		z-index: 100;
		border-radius: 5px;
		overflow: auto;
		padding-bottom: 10px;
	}
</style>
